import ReactFlow, { Background } from 'reactflow';
import 'reactflow/dist/style.css';

export default function Test() {
  const nodes = [
    { id: '1', position: { x: 0, y: 0 }, data: { label: 'Capital' }, type: 'default' },
    { id: '2', position: { x: 200, y: 100 }, data: { label: 'Treasury' }, type: 'default' },
    { id: '3', position: { x: 200, y: 200 }, data: { label: 'Issuing' }, type: 'default' },
  ];

  const edges = [
    { id: 'e1-2', source: '1', target: '2', animated: true, style: { stroke: 'purple' } },
    { id: 'e2-3', source: '2', target: '3', animated: true, style: { stroke: 'pink' } },
  ];

  return <ReactFlow nodes={nodes} edges={edges}><Background /></ReactFlow>;
}
